import { render, staticRenderFns } from "./RequestURL.vue?vue&type=template&id=efaa5484&scoped=true&"
import script from "./RequestURL.vue?vue&type=script&lang=js&"
export * from "./RequestURL.vue?vue&type=script&lang=js&"
import style0 from "./RequestURL.vue?vue&type=style&index=0&id=efaa5484&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaa5484",
  null
  
)

export default component.exports